export const TG_FIELD_REGEXP = /^https:\/\/t.me\/(.+)$/;
export const TG_PREFIX_REPLACE_REGEXP = /^https:\/\/t.me\//;
export const MANAGER_PAID_CLIENTS_MINIMUM_VALUE = 5;
export const INVITATION_TO_TEAM_LINK = 'telegiv.pro';

export const TG_FIELD_DEFAULT_VALUE = 'https://t.me/';
